import React from "react";
import { useHasModule } from "./useCapability";

/**
 * <ModuleBoundary moduleName="surveys"> — L1 frontend rendering enforcement.
 *
 * Hides any UI element belonging to a module not in the user's visible_modules.
 * Renders nothing when the module is absent — not a placeholder, not a skeleton,
 * not a "you don't have permission" notice. Pure absence (§3.1).
 *
 *   <ModuleBoundary moduleName="surveys">
 *       <SidebarItem to="/surveys">Surveys</SidebarItem>
 *   </ModuleBoundary>
 *
 * The optional `fallback` prop is an escape hatch for the rare case where
 * something MUST render (e.g., an empty-state hint for super-admins in
 * demo mode). It is OFF by default — the law's default is silence.
 */
export const ModuleBoundary = ({ moduleName, fallback = null, children }) => {
    const visible = useHasModule(moduleName);
    if (!visible) return fallback;
    return <>{children}</>;
};
